import { render } from "./UserVipLog.vue?vue&type=template&id=5258952c"
import script from "./UserVipLog.vue?vue&type=script&lang=js"
export * from "./UserVipLog.vue?vue&type=script&lang=js"

import exportComponent from "D:\\yiban\\WebProject\\yiban-admin\\node_modules\\.store\\vue-loader@16.8.3\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__